import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../../config/api";

export default function Profile() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [loading, setLoading] = useState(false);

  /* ================= FETCH PROFILE ================= */

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    if (!user) {
      navigate("/");
      return;
    }

    try {
      const res = await fetch(`${API.PROFILE}&id=${user.id}`);

      const data = await res.json();

      if (data.success) {
        setForm({
          name: data.user.name || "",
          email: data.user.email || "",
          phone: data.user.phone || "",
        });
      }
    } catch (err) {
      console.error("Error fetching profile:", err);
    }
  };

  /* ================= HANDLE CHANGE ================= */

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  /* ================= UPDATE PROFILE ================= */

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const user = JSON.parse(sessionStorage.getItem("user"));

    try {
      const res = await fetch(API.UPDATE_PROFILE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: user.id,
          ...form,
        }),
      });

      const data = await res.json();

      if (data.success || data.status) {
        // Update session
        const updatedUser = { ...user, ...form };
        sessionStorage.setItem("user", JSON.stringify(updatedUser));

        // refresh UI
        window.dispatchEvent(new Event("userLogin"));

        alert("Profile Updated Successfully");
      } else {
        alert(data.message || "Update failed");
      }
    } catch (err) {
      console.error("Update Error:", err);
      alert("Failed to update profile. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  /* ================= CLOSE ================= */

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <div className="profile-popup" onClick={handleClose}>
      <div className="profile-card" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}

        <button className="close-btn" onClick={handleClose}>
          ✖
        </button>

        <div className="profile-right">
          <div className="page-header">
            <h3>My Profile</h3>
            <p className="text-muted small">Update your personal information</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group mb-3">
              <label className="form-label">Full Name</label>

              <input
                type="text"
                name="name"
                className="form-control"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label">Email Address</label>

              <input
                type="email"
                name="email"
                className="form-control"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>

            <button className="update-btn w-100" disabled={loading}>
              {loading ? "Saving..." : "Update Profile"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
